import {
  type ISelectInputProps,
  SelectInput,
} from '@framework/form/inputs/SelectInput.tsx';
import { CustomWarningRuleType } from './ICustomWarningRule.ts';

export interface ICustomWarningRuleTypeSelectProps extends ISelectInputProps {}

const WarningTypeOptions = [
  {
    value: CustomWarningRuleType.Warning,
    label: 'Avviso',
  },
  {
    value: CustomWarningRuleType.Error,
    label: 'Errore',
  },
];

export function CustomWarningRuleTypeSelect(
  props: ICustomWarningRuleTypeSelectProps,
) {
  return <SelectInput options={WarningTypeOptions} {...props} />;
}
